import React from 'react';
import { CountryUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxForm } from './index';
import { AddressTaxFormPropTypes } from './shapes';

// Country, State, City are from the address object and not renaming to avoid confusion
export const getTaxFormatFromAddress = (countries, { Country, StateOrProvince, City }) => {
  const countryObject = CountryUtils.findCountry({ countries, countryCode: Country, withExtensions: true });
  return [(countryObject && countryObject.getRegion()) || '',
    Country || '',
    StateOrProvince || '',
    City || ''].map(segment => segment.trim()).join('/');
};

/**
 * Tax Form Component with address prop.
 * Tax format is generated using the address object.
 * @param {object} props - AddressTaxFormPropTypes
 * @returns {React.Component} Tax form corresponding to a given address/ BusinessLocation
 */
export const AddressTaxForm = props => (
  <TaxForm
    {...props}
    taxFormat={getTaxFormatFromAddress(props.countries, props.address || {})}
    mtTaxFormat={getTaxFormatFromAddress(props.countries, props.mtAddress || {})}
  />
);

AddressTaxForm.propTypes = AddressTaxFormPropTypes;
